// extracted by mini-css-extract-plugin
export default {"createAccount":"o5lRuzP2qawJJ_fNwNN8","login":"AQu67F6QrGcBQu5RpEdf"};